import * as trace from 'owa-trace';
import { hasQueryStringParameter } from 'owa-querystring';

/**
 * Add custom metric to the global _pageTimings object so that PAS tool can read and report in results
 */
export default function addPerfMetricToPageTimings(key: string, value: number): void {
    if (hasQueryStringParameter('cpm')) {
        try {
            window._pageTimings = window._pageTimings || {};
            window._pageTimings[key] = value;
        } catch (e) {
            trace.errorThatWillCauseAlert('addPerfMetricToPageTimings failed:' + e);
        }
    }
}
